// Shared by the React app and scripts/prerender.mjs so on-page and build-time JSON-LD stay identical.
export const SITE_URL = 'https://uspconsultancy.com.np';

export function buildOrganizationSchema(settings) {
  const { contact = {}, social = {} } = settings || {};
  const phones = Array.isArray(contact.phones) ? contact.phones : [];
  const sameAs = [social.facebook, social.linkedin, social.twitter].filter(
    (u) => typeof u === 'string' && /^https:\/\//i.test(u)
  );

  return {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    '@id': `${SITE_URL}/#organization`,
    name: contact.name || 'USP Consultancy',
    description:
      'Premier consulting firm specializing in socio-economic research, surveys, assessments and evaluations, policy analysis and capacity development solutions in Nepal',
    url: `${SITE_URL}/`,
    logo: `${SITE_URL}/usp.png`,
    image: `${SITE_URL}/usp.png`,
    foundingDate: '2017',
    email: contact.email,
    telephone: phones[0],
    address: {
      '@type': 'PostalAddress',
      streetAddress: contact.streetAddress,
      addressLocality: contact.locality,
      postalCode: contact.postalCode,
      addressCountry: contact.country,
    },
    ...(contact.latitude && contact.longitude
      ? { geo: { '@type': 'GeoCoordinates', latitude: contact.latitude, longitude: contact.longitude } }
      : {}),
    contactPoint: phones.map((telephone) => ({
      '@type': 'ContactPoint',
      telephone,
      email: contact.email,
      contactType: 'customer service',
      availableLanguage: ['English', 'Nepali'],
    })),
    areaServed: { '@type': 'Country', name: 'Nepal' },
    ...(sameAs.length ? { sameAs } : {}),
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Consulting Services',
      itemListElement: [
        ['Socio-Economic Research', 'Comprehensive socio-economic research and analysis'],
        ['Surveys and Assessments', 'Baseline, midline, and endline studies'],
        ['Policy Analysis', 'Policy research and advisory services'],
        ['Capacity Development', 'Training and capacity building solutions'],
      ].map(([name, description]) => ({
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name, description },
      })),
    },
  };
}
